import Header from '../../components/Header';
import LogoHeader from "../../components/LogoHeader";
import CustomButton from '../../components/CustomButton';
import parse, {Element} from "html-react-parser";
import NotFoundPage from "../../pages/NotFoundPage";

const Privacy = () => {
    if(!localStorage.getItem("privacy_policy")) {
        return <NotFoundPage isShowSubmitButton={false}/>
    }

    return (
        <div className='static md:inset-0 bg-alu-base h-vh'>
            <div className='w-full md:max-w-[50rem] static md:absolute left-1/2 md:transform md:-translate-x-1/2 md:py-[2.5rem] md:px-[2.25rem]'>
                <LogoHeader view="talent" page="advanced"></LogoHeader>
                <div className='bg-white md:rounded-2xl md:shadow-lg md:max-w-full md:m-auto md:min-h-max min-h-screen w-full px-0 py-0 md:px-10 md:py-6'>
                    <Header title="個人情報保護方針"></Header>
                    <div className="flex flex-col items-center justify-center mt-[2.5rem] md:mt-4 mx-4 md:mx-0">
                        <div className="mb-10 bg-[#F7F7F7] w-full px-4 py-3.5 pr-[0.375rem] rounded">
                            <div className="custom-scrollbar h-[35.625rem] overflow-y-auto">
                                <div className="w-full pr-[0.625rem] text-sm">
                                    <p className="mb-4 alu-text-base-2 whitespace-pre-line">
                                        {parse(localStorage.getItem("privacy_policy") || "")}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-center mb-8 md:mb-0">
                            <CustomButton onClick={() => window.close()} variant="gray" size="md" customStyle="min-w-fit md:min-w-[21.4375rem]">
                                閉じる
                            </CustomButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Privacy;
